import PropTypes from 'prop-types'
import { useMemo } from 'react'
import styled from 'styled-components/macro'

const PROGRESS_COLORS = {
  full: '#00d93b',
  halfway: '#FFCE4F',
  depleted: '#E80045',
}

const ExpirationBarContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
`

const ExpirationBarSlider = styled.div`
  position: absolute;
  width: 100%;
  height: 1px;
  flex-grow: 1;
  flex-shrink: 0;
  left: 0;
  background-color: rgba(109, 114, 120, 0.3);
`

const ExpirationBarProgress = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  height: 5px;
  border-radius: 4px;
  background-color: red;
  transition: transform 200ms linear, background-color 400ms linear;
  transform-origin: 0 100%;
`

function ExpirationBar(props) {
  const { remaining, fullThreshold, halfwayThreshold, ariaLabel } = props

  const colorState = useMemo(
    () =>
      remaining > fullThreshold ? 'full' : remaining > halfwayThreshold ? 'halfway' : 'depleted',
    [fullThreshold, halfwayThreshold, remaining]
  )

  const progressStyle = useMemo(
    () => ({
      transform: `scaleX(${remaining > 100 ? 1 : remaining < 0 ? 0 : Math.round(remaining) / 100})`,
      backgroundColor: PROGRESS_COLORS[colorState],
    }),
    [colorState, remaining]
  )

  return (
    <ExpirationBarContainer>
      <ExpirationBarSlider />

      <ExpirationBarProgress
        role="progressbar"
        aria-valuenow={remaining}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={ariaLabel || `${remaining}% time left`}
        style={progressStyle}
      />
    </ExpirationBarContainer>
  )
}

ExpirationBar.propTypes = {
  remaining: PropTypes.number,
  fullThreshold: PropTypes.number,
  halfwayThreshold: PropTypes.number,
  ariaLabel: PropTypes.string,
}

ExpirationBar.defaultProps = {
  remaining: 100,
  fullThreshold: 66,
  halfwayThreshold: 33,
  ariaLabel: null,
}

export { ExpirationBar, PROGRESS_COLORS }
